import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Types ───

export interface UserRow {
  id: string;
  email: string | null;
  display_name: string | null;
  photo_url: string | null;
  updated_at: string | null;
  updated_by: string | null;
}

export interface UserProviderLinkRow {
  id: string;
  org_id: string | null;
  clinic_id: string | null;
  user_id: string | null;
  provider_id: string | null;
  status: string | null;
  created_at: string | null;
  updated_at: string | null;
}

// ─── Queries ───

export function qUserById(userId: string): QuerySpec<[string]> {
  return {
    key: ['user', userId] as const,
    sql: `SELECT * FROM users WHERE id = ?`,
    params: [userId],
    watch: ['users'],
  };
}

/** All users, ordered by display name (falling back to email). For filters/pickers. */
export function qUsersList(): QuerySpec<[]> {
  return {
    key: ['users', 'list'] as const,
    sql: `SELECT id, email, display_name, photo_url, updated_at, updated_by
            FROM users
           ORDER BY COALESCE(display_name, email) COLLATE NOCASE ASC`,
    params: [],
    watch: ['users'],
  };
}

export function qUserProviderLink(orgId: string, userId: string): QuerySpec<[string, string]> {
  return {
    key: ['user-provider-link', orgId, userId] as const,
    sql: `SELECT * FROM user_provider_links WHERE org_id = ? AND user_id = ? AND status = 'active' LIMIT 1`,
    params: [orgId, userId],
    watch: ['user_provider_links'],
  };
}
